import { createSlice } from "@reduxjs/toolkit";
import { updateFnolInstanceLogic } from "store/UpdateFnolInstanceState";
import { resetOnPropertyChangeData } from "./fnolOnPropertyChangeSlice";

const initialState = {
  componentValues: { byFieldMappingId: {} },
  fieldMappingLookup: {},
};

// create slice uses immer internally, so can directly mutate state in reducers. See Redux toolkit docs. /MB.
const fnolInstanceSlice = createSlice({
  name: "fnolInstance",
  initialState,
  reducers: {
    updateFnolInstanceComponent(state, action) {
      const fieldMappingId = action.payload.props.fieldMappingId;
      if (fieldMappingId === undefined || fieldMappingId === null) {
        return state;
      }
      const updatedFnolInstanceState = updateFnolInstanceLogic(
        Object.entries(state.componentValues.byFieldMappingId).values(),
        action.payload.fieldValue,
        action.payload.props,
        action.payload.dropdownId,
        action.payload.autoPopulatedBy
      );
      updatedFnolInstanceState.forEach((component) => updateStateValues(component, state));
    },
    updateFnolInstance(state, action) {
      action.payload.forEach((component) => updateStateValues(component, state));
    },
  },
});

const updateStateValues = (component, state) => {
  if (!component.fieldMappingId || !component.fieldMapping) {
    return;
  }

  if (component.value !== null) {
    state.componentValues.byFieldMappingId[component.fieldMappingId] = component;
    state.fieldMappingLookup[component.fieldMapping] = component.fieldMappingId;
  } else {
    state.fieldMappingLookup[component.fieldMapping] = component.fieldMappingId;
    delete state.componentValues.byFieldMappingId[component.fieldMappingId];
  }
};

export const { updateFnolInstanceComponent, updateFnolInstance } = fnolInstanceSlice.actions;

export default fnolInstanceSlice.reducer;
